import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ConnectorService, UserVariable } from '../connector.service';
import { NotificationsService } from '../notifications.service';
import { CampaignService, Campaign } from '../services/campaign.service';
import { PreferencesService, NewsTickerSpeed } from '../services/preferences.service';
import { PreferencesBottomSheetComponent } from './preferences-bottom-sheet/preferences-bottom-sheet.component';
import packageJson from '../../../package.json';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  version: string = packageJson.version;
  campaigns: Campaign[] = [];
  isDisconnecting = false;

  constructor(
    private http: HttpClient,
    private connector: ConnectorService,
    public notificationsService: NotificationsService,
    private campaignService: CampaignService,
    public preferencesService: PreferencesService,
    private bottomSheet: MatBottomSheet
  ) {}

  ngOnInit(): void {
    if(!this.connector.isConnected()){
      this.connector.disconnection();
    }

    if(!this.notificationsService.isThisDeviceSubscribedToNotifications()){
      // Alors on affiche une pop-up pour demander l'autorisation de recevoir des notifications
      this.notificationsService.requestNotificationPermission().then((permission) => {
        if (permission === 'granted') {
          this.notificationsService.subscribeToNotifications();
          this.notificationsService.showNotification('Inscription réussie', 'Vous allez recevoir des notifications sur cet appareil.');
        } else if (permission === 'denied') {
          this.notificationsService.showNotification('Inscription échouée', 'Vous ne recevrez pas de notifications sur cet appareil.');
        } else {
          this.notificationsService.showNotification('Inscription annulée', 'Vous n\'avez pas répondu à la demande d\'inscription aux notifications.');
        }
      });
    }

    // Charger les campagnes actives
    this.loadActiveCampaigns();
  }

  loadActiveCampaigns() {
    this.campaignService.getPublicCampaigns().subscribe({
      next: (campaigns) => {
        this.campaigns = campaigns.filter(campaign => campaign.is_active);
      },
      error: (err) => {
        console.error('Erreur lors du chargement des campagnes:', err);
      }
    });
  }

  showTooltip(tooltip: any) {
    tooltip.show();  // Afficher immédiatement
    setTimeout(() => tooltip.hide(), 3000); // Disparaît après 3 sec
  }
  

  openPreferences() {
    this.bottomSheet.open(PreferencesBottomSheetComponent, {
      panelClass: 'prefs-bottom-sheet'
    });
  }

  getUsername():string{
    return this.connector.getValue(UserVariable.USERNAME);
  }

  getFirstname():string{
    const name = this.connector.getValue(UserVariable.FIRSTNAME);
    if (!name) return '';
    return name.toLowerCase().replace(/\b\w/g, (c: string) => c.toUpperCase());
  }

  getEmail():string{
    return this.connector.getValue(UserVariable.EMAIL);
  }

  isAdherent():boolean{
    return this.connector.isAdherent();
  }

  isSocio():boolean{
    return this.connector.isSocio();
  }

  async disconnect() {
    if (this.isDisconnecting) {
      return;
    }

    this.isDisconnecting = true;

    try {
      await this.connector.disconnection();
    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);
      this.isDisconnecting = false; // Réactiver le bouton en cas d'erreur
    }
  }

  reload(): void {
    this.notificationsService.getInAppNotifications();
    this.loadActiveCampaigns();
  }
}
